import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TextInput from "../common/formfields/TextInput"
import TextArea from "../common/formfields/TextArea"
import SelectInput from "../common/formfields/SelectInput"
import CheckboxInput from "../common/formfields/CheckboxInput"

const GroupForm = ({
    group,
    onSave,
    onCancel,
    onChange,
    saving = false,
    errors = {}
}) => {
    return (
        <form onSubmit={onSave} className="">
            {errors.onSave && (
                <div className="alert alert-danger" role="alert">
                    {errors.onSave}
                </div>
            )}

            <TextInput
                name="name"
                type="text"
                label="Group Name"
                maxLength="100"
                value={group.name}
                onChange={onChange}
                error={errors.name}
            />

            <TextArea
                name="description"
                label="Description"
                maxLength="500"
                cols="75"
                rows="6"
                value={group.description}
                onChange={onChange}
                error={errors.description}
            />

            <TextInput
                name="friendlyUrl"
                type="text"
                label="https://www.justgoride.co.uk/groups/[GROUP URL]"
                maxLength="100"
                placeholder="Group Url"
                value={group.friendlyUrl}
                onChange={onChange}
                error={errors.friendlyUrl}
            />

            <SelectInput
                name="access"
                label="Group Access"
                value={group.access || ""}
                defaultOption="Select Group Access Level"
                options={[
                    {
                        value: "Public",
                        text: "Public"
                    },
                    {
                        value: "PublicClosed",
                        text: "Public Closed (requires approval to join)"
                    },
                    {
                        value: "Private",
                        text: "Private (Invitation only)"
                    }
                ]}
                onChange={onChange}
                error={errors.access}
            />

            <TextArea
                visible={group.access === "PublicClosed"}
                name="joiningInfo"
                label="Joining Information"
                maxLength="1000"
                cols="75"
                rows="6"
                value={group.joiningInfo}
                onChange={onChange}
                error={errors.joiningInfo}
            />

            <button type="submit" disabled={saving} className="btn btn-info float-right">
                {saving ? "Saving..." : "Save"}
            </button>
            <button className="btn btn-link float-right mr-1" onClick={onCancel}>
                Cancel
            </button>


            </form>

    );
}

GroupForm.propTypes = {
    group: PropTypes.object.isRequired,
    errors: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    saving: PropTypes.bool
}

export default GroupForm;


// WEBPACK FOOTER //
// ./src/components/groups/GroupForm.js